/* eslint-disable no-unreachable */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import NumberFormat from 'react-number-format';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../actions';
import * as c from '../constants';

function CashoutModal({
  history,
  creating,
  cashOut,
  mobileNo,
  onReloadCashOut,
}) {
  const setModal = useContext(ModalContext);

  const [formData, setFormData] = useState({
    amount: ''
  });

  const commonValidation = {
    amount: 'required',
  }

  const validateForm = useFormValidator(
    formData,
    commonValidation,
  );

  const handleOnSubmit = e => {
    e.preventDefault();
    const args = {
      ...formData,
      mobile_number: mobileNo
    }

    cashOut(args, () => {
      setModal({ isOpen: false });
      setFormData({
        mobile_number: mobileNo
      });
      onReloadCashOut();
      history.push('/wallet-support/wallet-history');
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  // const onChange = (e) => {
  //   return setFormData({
  //     ...formData,
  //     [e.target.name]:
  //       e.target.type === 'checkbox' ? e.target.checked : e.target.value,
  //   });
  // };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row m-1 p-1">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Enter Amount &nbsp; {validateForm.renderMessage('amount')}
            </label>
            <NumberFormat
              name="amount"
              id="amount"
              placeholder="0"
              className="form-control"
              onValueChange={values => {
                const { floatValue } = values;
                setFormData({
                  ...formData,
                  amount: floatValue,
                });
              }}
              /* eslint-disable */
              isNumericString={true}
              thousandSeparator={true}
              allowNegative={true}
              allowLeadingZeros={true}
              displayType="input"
              prefix=""
              value={`${_.get(formData, 'amount', '')}` || ''}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CashoutModal.defaultProps = {
  mobileNo: '',
  onReloadCashOut: '',
}

CashoutModal.propTypes = {
  onReloadCashOut: PropTypes.instanceOf(Function),
  cashOut: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  creating: PropTypes.bool.isRequired,
  mobileNo: PropTypes.string,
};

const mapStateToProps = ({ api }) => ({
  creating: api.loading.indexOf(c.CASH_OUT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CashoutModal);
